import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { combineLatest, map, switchMap, first, tap } from 'rxjs';
import { filterIsNotUndefined } from '@kaseya-utils';
import { K365SetupGuidesAccessFacade } from '@layout/k365-setup-guides-access/facades/k365-setup-guides-access.facade';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { Permission } from '@core/permissions/models/permission.enum';
import { AuthorizationService } from '@core/authorization/services/authorization.service';

export const hasSetupGuidesAccessGuard: CanMatchFn = () => {
  const facade = inject(K365SetupGuidesAccessFacade);
  const permissionsFacade = inject(PermissionsFacade);
  const authorizationService = inject(AuthorizationService);
  const router = inject(Router);

  return permissionsFacade.permissionsLoaded$.pipe(
    first(),
    tap(() => {
      if (!permissionsFacade.hasPermission(Permission.OnboardingSubscriptionsView)() || authorizationService.isMigratedUser()) {
        facade.setSetupGuidesAccessInactive();
      } else {
        facade.loadSetupGuidesAccessIfNotLoaded();
      }
    }),
    switchMap(() => combineLatest([facade.setupGuidesAccess$, facade.loading$, facade.error$])),
    map(([hasAccess, isLoading, hasError]) => {
      if (isLoading) {
        return undefined;
      }

      if (hasError || !hasAccess) {
        return router.createUrlTree(['']);
      }

      return true;
    }),
    filterIsNotUndefined()
  );
};
